import script from "./TheLogCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./TheLogCreator.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__